module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$lang.labels.catalogActivationText))]), _vm._v(" "), _c('v-checkbox', {
    key: _vm.index,
    attrs: {
      "hide-details": "",
      "color": "primary",
      "error": _vm.moon.error,
      "success": _vm.moon.success,
      "label": _vm.$lang.labels.moon
    },
    model: {
      value: (_vm.moon.activate),
      callback: function($$v) {
        _vm.$set(_vm.moon, "activate", $$v)
      },
      expression: "moon.activate"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_vm._l((_vm.webshops), function(webshop, index) {
    return [_c('v-checkbox', {
      key: index,
      attrs: {
        "hide-details": "",
        "color": "primary",
        "error": webshop.error,
        "success": webshop.success,
        "value": webshop.id,
        "label": ((_vm.$lang.labels.webshop) + " - " + (webshop.name))
      },
      model: {
        value: (_vm.selectedWebshops),
        callback: function($$v) {
          _vm.selectedWebshops = $$v
        },
        expression: "selectedWebshops"
      }
    })]
  })], 2), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.no))]), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.activate()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.yes))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b21d730","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/CatalogActivationModal.vue
// module id = 580
// module chunks = 9